<template>
  <div class="wrap">
    <div class="vertical-line left"></div>
    <div class="top-content">
      <div class="text-wrap">
        <div class="title first">잠자는 국회<span class="blue-dot"></span></div>
        <span class="bg-and">&</span>
        <div class="title">입법평론</div>

        <div class="sub-title" v-html="title"></div>
        <div class="sub-title sub" v-html="subTitle"></div>

        <div class="button-wrap pc">
          <RouterLink to="/about"
            ><span class="show-detail black" type="button"
              >잠자는국회 자세히보기</span
            ></RouterLink
          >
          <a href="https://lawscool.co.kr/" target="_blank"
            ><span class="show-detail" type="button"
              >입법평론 자세히보기</span
            ></a
          >
          <span class="button-dot"></span>
        </div>
      </div>
      <div class="sub-img-wrap">
        <div class="sub-img sub_1"></div>
        <div class="sub-img sub_2"></div>
      </div>
      <div class="button-wrap mobile">
        <RouterLink to="/about"
          ><span class="show-detail black" type="button"
            >잠자는국회 자세히보기</span
          ></RouterLink
        >
        <a href="https://lawscool.co.kr/" target="_blank"
          ><span class="show-detail" type="button">입법평론 자세히보기</span></a
        >
      </div>
    </div>
    <SubMainMenu />
    <MainBottom />
    <div class="vertical-line"></div>
  </div>
</template>

<script>
import SubMainMenu from "./SubMainMenu.vue";
import MainBottom from "./MainBottom.vue";
import { RouterLink } from "vue-router";

export default {
  name: "SubMain",
  components: { SubMainMenu, MainBottom, RouterLink },

  data() {
    return {
      title: "잠자는 국회는 입법평론과 함께 합니다.",
      subTitle:
        "입법평론은 국회의원의 입법 활동에 대한 분석과 해설입니다.<br />숫자가 아닌 내용 중심의 의정활동 평가를 위한 기초 자료입니다.",
    };
  },

  mounted() {
    window.addEventListener("resize", this.checkScreenWidth);

    if (window.innerWidth <= 1040) {
      this.title = "잠자는 국회는 입법평론과<br/>함께 합니다.";
      this.subTitle =
        "입법평론은 국회의원의 입법 활동에<br/>대한 분석과 해설입니다.<br />숫자가 아닌 내용 중심의 의정활동 평가를<br/>위한 기초 자료입니다.";
    } else {
      this.title = "잠자는 국회는 입법평론과 함께 합니다.";
      this.subTitle =
        "입법평론은 국회의원의 입법 활동에 대한 분석과 해설입니다.<br />숫자가 아닌 내용 중심의 의정활동 평가를 위한 기초 자료입니다.";
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
  },

  methods: {
    checkScreenWidth() {
      if (window.innerWidth <= 1040) {
        this.title = "잠자는 국회는 입법평론과<br/>함께 합니다.";
        this.subTitle =
          "입법평론은 국회의원의 입법 활동에<br/>대한 분석과 해설입니다.<br />숫자가 아닌 내용 중심의 의정활동 평가를<br/>위한 기초 자료입니다.";
      } else {
        this.title = "잠자는 국회는 입법평론과 함께 합니다.";
        this.subTitle =
          "입법평론은 국회의원의 입법 활동에 대한 분석과 해설입니다.<br />숫자가 아닌 내용 중심의 의정활동 평가를 위한 기초 자료입니다.";
      }
    },
  },
};
</script>

<style scoped>
.wrap {
  padding-top: 70px;
  position: relative;
  overflow: hidden;
  height: 2205px;

  @media only screen and (max-width: 1200px) {
    height: 218vw;
  }

  @media only screen and (max-width: 1040px) {
    height: auto;
  }
}

.vertical-line {
  height: 100%;
  position: absolute;
  right: 220px;
  width: 1px;
  background-color: #e6e6e6;
  top: 0;

  @media only screen and (max-width: 1040px) {
    display: none;
  }
}

.vertical-line.left {
  right: auto;
  left: 220px;
  height: 1200px;
  bottom: 0;
  top: auto;

  @media only screen and (max-width: 1200px) {
    height: 1350px;
  }
}

.top-content {
  position: absolute;
  top: 70px;
  z-index: 2;
  display: flex;
  left: 300px;
  right: 300px;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  gap: 30px;

  @media only screen and (max-width: 1040px) {
    flex-direction: column;
    gap: 62px 60px;
  }
}

.title {
  font-size: 50px;
  font-weight: bold;
  color: #000;
  margin-top: 60px;

  @media only screen and (max-width: 1380px) {
    font-size: 46px;
  }

  @media only screen and (max-width: 1040px) {
    width: 100%;
    text-align: center;
  }
}

.title.first {
  margin-bottom: 19px;
  position: absolute;
  margin-top: 0;
  z-index: 2;
}

.sub-title {
  font-size: 30px;
  font-weight: 500;
  color: #666;
  margin-top: 79px;

  @media only screen and (max-width: 1380px) {
    font-size: 26px;
  }

  @media only screen and (max-width: 1040px) {
    margin-top: 58px;
    width: 100%;
    text-align: center;
  }
}

.sub-title.sub {
  font-size: 20px;
  margin-top: 28px;
  font-weight: 500;
  letter-spacing: -0.5px;
  color: #b5b5b5;

  @media only screen and (max-width: 1380px) {
    font-size: 16px;
  }
}

.show-detail {
  display: inline-block;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.5px;
  height: 60px;
  padding: 0 35px;
  line-height: 60px;
  border-radius: 30px;
  background-color: #005aab;
  margin-top: 79px;

  &.black {
    background-color: #000000;
  }

  @media only screen and (max-width: 1040px) {
    margin-top: 0;
    width: 300px;
  }
}

.sub-img {
  width: 280px;
  height: 380px;
  border-radius: 20px;
  background-position: -150px center;
  background-size: 710px;

  @media only screen and (max-width: 1200px) {
    width: 220px;
  }

  @media only screen and (max-width: 512px) {
    width: 40vw;
  }
}
.sub-img.sub_1 {
  margin-top: 70px;
  background-image: url("../../assets/img/main_sub_1.jpg");
}

.sub-img.sub_2 {
  background-image: url("../../assets/img/main_sub_2.jpg");
}

.sub-img-wrap {
  display: flex;
  gap: 30px;

  @media only screen and (max-width: 420px) {
    gap: 20px;
  }
}

.text-wrap {
  position: relative;
}

.blue-dot {
  width: 10px;
  height: 10px;
  background-color: #005aab;
  display: inline-block;
  border-radius: 50%;
  position: absolute;
  left: 250px;
  top: -16px;

  @media only screen and (max-width: 1040px) {
    left: auto;
  }
}

.bg-and {
  position: absolute;
  font-size: 100px;
  font-weight: bold;
  letter-spacing: -2.5px;
  color: #e6e6e6;
  left: 230px;
  top: 20px;
  z-index: 1;
  font-family: GmarketSansMedium;
  font-size: 100px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -2.5px;

  @media only screen and (max-width: 1040px) {
    left: auto;
    right: 82px;
    top: 17px;
  }

  @media only screen and (max-width: 528px) {
    right: 0;
  }
}

.button-wrap {
  position: relative;
  display: flex;
  gap: 20px;

  &.mobile {
    display: none;
  }

  @media only screen and (max-width: 1040px) {
    &.pc {
      display: none;
    }
    &.mobile {
      margin-top: 0;
      display: flex;
      text-align: center;
      flex-direction: column;
    }
  }
}

.button-dot {
  width: 26px;
  height: 26px;
  display: inline-block;
  opacity: 0.23;
  background-color: #009e96;
  border-radius: 50%;
  position: absolute;

  /* @todo 이거 하단 하고 위치잡기 */
  bottom: 0;
  left: 0;
}
</style>
